import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS,I_COMMON_DELETE_PARAMS} from './_base';

import I_FILTER from '../interfaces/I_FILTERS';
import {
  getFiltersResponse,
  postFilterResponse,
  deleteFilterResponse,
  putFilterResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- FILTERS
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  user_id: number;
  type?: string;
}
/**
 * Récupère la liste des filtres
 * @param obj
 * @returns
 */
const getList = async ({
  accessToken,refreshToken,
  dispatch,state,
  user_id,
  type,
}:I_GET_PARAMS):Promise<I_FILTER[]> => {
  logger.debug('ApiServices - getFilters - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getFiltersResponse({
        accessToken:usedAccessToken,
        user_id,
        type,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getFilters - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_FILTER[] = await response.json();
  logger.debug('ApiServices - getFilters - ok, returned body',body);
  return body;
};

interface I_CREATE_FILTER_PARAMS {
  accessToken: string,
  refreshToken: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401

  user_id?: number;
  name: string;
  type: string;
  data: object;
}
/**
 * Crée un filtre
 * @param param0
 * @returns
 */
const create = async ({
  accessToken,refreshToken,
  dispatch,state,
  user_id,name,type,data,
}:I_CREATE_FILTER_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createFilter - ...');
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    !name || name === null || name.trim() === '' ||
    !type || type === null || type.trim() === '' ||
    user_id === undefined || user_id === null ||
    data === undefined || data === null
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to post filter',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postFilterResponse({
        accessToken:usedAccessToken,
        user_id,
        name,type,data,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createFilter - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createFilter - ok, returned body',body);
  logger.info(...formatInfo('Filter created!'));
  return body;
};

interface I_DELETE_PARAMS extends I_COMMON_DELETE_PARAMS {
  user_id: number;
}
/**
 * Supprime un filtre
 * @param param0
 * @returns
 */
const remove = async ({
  accessToken,refreshToken,
  dispatch,state,
  id,
  user_id,
}:I_DELETE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - deleteFilter - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteFilterResponse({
        accessToken:usedAccessToken,
        id,
        user_id,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteFilter - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteFilter - ok, returned body',body);
  logger.info(...formatInfo('Filter deleted!'));
  return body;
};


interface I_PUT_PARAMS {
  accessToken?: string;
  refreshToken?: string;
  id: number;
  user_id: number;
  name: string;
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Modifie un filtre
 * @param param0
 * @returns
 */
const update = async ({
  accessToken,refreshToken,
  dispatch,state,
  id,
  user_id,
  name,
}:I_PUT_PARAMS):Promise<string> => {
  logger.debug('ApiServices - updateFilter - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    !name || name === null || name.trim() === ''
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing name',
      errorMessage: 'Missing name to post filter',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putFilterResponse({
        accessToken:usedAccessToken,
        id,
        user_id,
        name,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateFilter - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateFilter - ok, returned body',body);
  logger.info(...formatInfo('Filter updated!'));
  return body;
};

const CustomersServices = {
  getList,
  create,
  remove,
  update,
};

export default CustomersServices;
